import { Box, Typography, Button, Paper } from "@mui/material";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { useNavigate } from "react-router-dom";

const DemoSection = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ 
        mt: 10, 
        mb: 10, 
        display: "flex", 
        justifyContent: "center",
        px: { xs: 2, md: 0 }
    }}>
      <Paper
        elevation={4}
        sx={{
          p: { xs: 3, md: 5 },
          maxWidth: { xs: 'none', md: 600 },
          width: "100%",
          textAlign: "center",
          backgroundColor: (theme) => theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[100],
        }}
      >
        <Typography variant="h5" gutterBottom>
          Try a Live Demo—No Signup Needed!
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Experience AnnoGram’s core features instantly. No account or email required.
        </Typography>
        <Button
          variant="contained"
          color="secondary"
          size="large"
          startIcon={<PlayCircleOutlineIcon />}
          onClick={() => navigate("/annogram")}
        >
          Launch Demo
        </Button>
      </Paper>
    </Box>
  );
};

export default DemoSection;